import classNames from 'classnames';
import React from 'react';

import DownloadButton from 'sharedreact/components/DownloadButton';

type Props = {
  id: string,
  className?: string,
  icon?: string,
  title: string,
  description: string,
  downloadTitle: string,
  downloadUrl?: string,
  filename?: string,
  openNewTab?: boolean,
  buttonType?: string
};

class DownloadCard extends React.Component<Props> {
  renderMultilineText (text: string) {
    let lines = [];
    const separatedText: string[] = text.split('\n');

    lines.push(<span key={0}>{separatedText[0]}</span>);

    for (let lineIndex = 1; lineIndex < separatedText.length; lineIndex++) {
      lines.push(<br key={lineIndex * 2 - 1} />);
      lines.push(<span key={lineIndex * 2}>{separatedText[lineIndex]}</span>);
    }

    return lines;
  }

  override render (): React.ReactNode {
    const { id, icon, title, description, downloadTitle,
      downloadUrl, filename, openNewTab, buttonType, className } = this.props;

    return (
      <div className={classNames(className, 'webappslauncher-download-card')}>
        {icon &&
          <div>
            <img src={icon} alt='' className='webappslauncher-download-icon-size' />
          </div>
        }
        <div className='webappslauncher-download-title-description'>
          <h3>{title}</h3>
          <div className='webappslauncher-download-description'>{this.renderMultilineText(description)}</div>
        </div>
        <div>
          {buttonType === 'none'
          ? <div className='webappslauncher-download-button-size' />
          : <DownloadButton id={id + '_download'}
            type={buttonType}
            downloadUrl={downloadUrl || ''}
            fileName={filename}
            openNewTab={openNewTab}
          >
            {downloadTitle}
          </DownloadButton>
          }
        </div>
      </div>
    );
  }
}

export default DownloadCard;
